import React from 'react'

const ModalConfirm = (props) => {
    const { title, text, textButtonClose, textButtonAccept, accept, load, error_message } = props
    return (
        <div id="modalConfirm" className="modal" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
                <div className="modal-content">

                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <p>{text}</p>
                    </div>

                    {!load && <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">{textButtonClose || 'Fechar'}</button>
                        <button type="button" className="btn btn-primary" onClick={() => accept ? accept() : null} >{textButtonAccept || 'OK'}</button>
                    </div>}

                    {load && <div className="modal-footer">
                        <div className="spinner-border" role="status" style={{margin:'5%'}}>
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>}
                </div>
            </div>
        </div>
    )
}

export default ModalConfirm